<aside class="sidebar">
  <header class="brand-row">
    <a class="logo-badge" routerLink="/" aria-label="Go to {{ appName }} home">
      <svg
        viewBox="0 0 40 40"
        fill="none"
        width="44"
        height="44"
        aria-hidden="true"
      >
        <defs>
          <linearGradient
            id="sb-g"
            x1="0"
            y1="0"
            x2="40"
            y2="40"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#e91e8c" />
            <stop offset="1" stop-color="#9d1256" />
          </linearGradient>
        </defs>
        <rect width="40" height="40" rx="10" fill="url(#sb-g)" />
        <rect
          x="13"
          y="5"
          width="22"
          height="14"
          rx="3.5"
          fill="white"
          opacity="0.45"
        />
        <path d="M16 19 L12 25 L21 19 Z" fill="white" opacity="0.45" />
        <rect x="5" y="20" width="22" height="14" rx="3.5" fill="white" />
        <path d="M24 34 L28 39 L18 34 Z" fill="white" />
      </svg>
    </a>
    <div class="brand-copy">
      <h1>{{ appName }}</h1>
    </div>
    <button
      class="theme-toggle-btn sidebar-theme"
      type="button"
      (click)="toggleDarkMode.emit()"
      [attr.aria-label]="darkMode() ? 'Light mode' : 'Dark mode'"
    >
      @if (darkMode()) {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="4" />
          <path
            d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"
          />
        </svg>
      } @else {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
        </svg>
      }
    </button>
  </header>

  <section class="user-card" aria-label="Your guest profile">
    <button
      class="user-card-btn"
      type="button"
      (click)="openProfile.emit()"
      aria-label="Edit profile"
    >
      <div class="avatar avatar-large">
        <app-user-avatar [name]="displayName()" [avatarUrl]="avatarUrl()" />
      </div>
      <div class="user-meta">
        <strong>{{ displayName() }}</strong>
        <span>Guest Account</span>
      </div>
    </button>
  </section>

  <button class="primary-action" type="button" (click)="startNewChat.emit()">
    <svg
      class="chat-icon"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 18H70C78 18 84 24 84 32V70C84 78 78 84 70 84H58L50 93L42 84H30C22 84 16 78 16 70V32C16 24 22 18 30 18Z"
        fill="none"
        stroke="currentColor"
        stroke-width="7"
        stroke-linejoin="round"
      />
      <path
        d="M29 39H71"
        stroke="currentColor"
        stroke-width="7"
        stroke-linecap="round"
      />
      <path
        d="M29 59H60"
        stroke="currentColor"
        stroke-width="7"
        stroke-linecap="round"
      />
    </svg>
    Start New Chat
  </button>
</aside>
